import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import { connect } from 'react-redux';

import { ContactRecord } from '../entities/records';
import * as selectors from '../entities/Contact/selectors';

function mapStateToProps(state, { contactsIds }) {
  return {
    contacts: selectors.contactsByIds(state, contactsIds),
  };
}

export default compose(
  setPropTypes({
    contactsIds: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  connect,
  setPropTypes({
    contacts: PropTypes.arrayOf(PropTypes.instanceOf(ContactRecord)),
  }),
)(mapStateToProps);
